// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see BookletInteractViewScreenEvent
 */
export var BookletInteractViewScreen = function (_a) {
    var contentToken = _a.contentToken, flowToken = _a.flowToken, referrerFlowToken = _a.referrerFlowToken, origin = _a.origin;
    return ({
        name: "Booklet Interact ViewScreen",
        parameters: {
            cdf_entity: "Booklet",
            cdf_action: "Interact",
            content_token: contentToken !== undefined && contentToken !== null ? contentToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BookletInteractScrollEvent
 */
export var BookletInteractScroll = function (_a) {
    var contentToken = _a.contentToken, flowToken = _a.flowToken, referrerFlowToken = _a.referrerFlowToken;
    return ({
        name: "Booklet Interact Scroll",
        parameters: {
            cdf_entity: "Booklet",
            cdf_action: "Interact",
            content_token: contentToken !== undefined && contentToken !== null ? contentToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BookletInteractTapButtonEvent
 */
export var BookletInteractTapButton = function (_a) {
    var contentToken = _a.contentToken, flowToken = _a.flowToken, referrerFlowToken = _a.referrerFlowToken, buttonText = _a.buttonText, buttonLocation = _a.buttonLocation;
    return ({
        name: "Booklet Interact TapButton",
        parameters: {
            cdf_entity: "Booklet",
            cdf_action: "Interact",
            content_token: contentToken !== undefined && contentToken !== null ? contentToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            button_text: buttonText !== undefined && buttonText !== null ? buttonText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            button_location: buttonLocation !== undefined && buttonLocation !== null ? buttonLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BookletInteractDismissScreenEvent
 */
export var BookletInteractDismissScreen = function (_a) {
    var contentToken = _a.contentToken, flowToken = _a.flowToken, referrerFlowToken = _a.referrerFlowToken;
    return ({
        name: "Booklet Interact DismissScreen",
        parameters: {
            cdf_entity: "Booklet",
            cdf_action: "Interact",
            content_token: contentToken !== undefined && contentToken !== null ? contentToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
